(() => {
  const agent = navigator.userAgent.toLowerCase();
  if (agent.includes('googlebot')) {
    toggleExperimentSectionVisibility("hidden");
    return
  }

  runAbTest();
})();

function runAbTest() {
  const cookieName = 'ab_test_section_version';
  const cookieLifetimeDays = 3;

  const originalId = window.machinePDP?.defaultSectionId || null;
  const experimentId = window.machinePDP?.experimentSectionId || null;

  if (!originalId) return;

  toggleExperimentSectionVisibility("hidden");

  if (!experimentId) {
    toggleOriginalSectionVisibility(originalId, "visible");
    return;
  }

  let version = getCookie(cookieName);

  if (!version) {
    version = getRandomVariant();
    setCookie(cookieName, version, cookieLifetimeDays);
  }

  if (version === 'original') {
    toggleOriginalSectionVisibility(originalId, "visible");
    removeExperimentSectionContainer(experimentId);
  } else {
    toggleOriginalSectionVisibility(originalId, "hidden");
    toggleExperimentSectionVisibility("visible");
  }
}

function toggleOriginalSectionVisibility(sectionId, visibility) {
  const element = document.getElementById(sectionId);
  if (!element) return;

  visibility === "hidden"
    ? element.remove()
    : element.classList.remove('async-hide')
}

function toggleExperimentSectionVisibility(visibility) {
  visibility === "hidden"
    ? window.abTestExperimentSectionHidden = true
    : window.abTestExperimentSectionHidden = false
}

function removeExperimentSectionContainer(experimentId) {
  const experimentSection = document.querySelector(experimentId);
  if (experimentSection) experimentSection.remove()
}

function getRandomVariant() {
  return Math.random() < 0.5 ? 'original' : 'experiment';
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value};${expires};path=/`;
}

function getCookie(name) {
  const cookies = Object.fromEntries(
    document.cookie.split('; ').map(cookieString => cookieString.split('='))
  );
  return cookies[name] ? decodeURIComponent(cookies[name]) : null;
}

